'use client'

import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearchNext } from 'react-instantsearch-nextjs'
import { Configure } from 'react-instantsearch'

import FilterToolbar from '@/components/filters/FilterToolbar'
import FilterModal from '@/components/filters/FilterModal'
import FilterModalFooter from '@/components/filters/FilterModalFooter'
import FilterModalComponents from '@/components/filters/FilterModalComponents'
import FilterSearchBox from '../filters/FilterSearchBox'

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
)

export default function BusinessDirectoryInner({ ResultsTemplate, algoliaIndex, filters }) {
  return (
    <div>
      <InstantSearchNext
        searchClient={searchClient}
        indexName={algoliaIndex}
        routing
        future={{
          preserveSharedStateOnUnmount: true,
          persistHierarchicalRootCount: true,
        }}>
        <Configure hitsPerPage={999} />

        <FilterToolbar
          leftChildren={
            <div className="flex w-full items-center gap-x-s">
              <FilterModal footerComponent={<FilterModalFooter />}>
                <FilterModalComponents filters={filters} />
              </FilterModal>
            </div>
          }
          rightChildren={
            <div className={`flex w-full justify-end gap-x-s`}>
              <FilterSearchBox />
            </div>
          }
        />

        <ResultsTemplate />
      </InstantSearchNext>
    </div>
  )
}
